import { useAppDispatch } from '../../../../store/hooks'
import { setCrossClientSearch } from '../../../../store/crossClient/crossClientResults'
import { Form } from 'react-bootstrap'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { useSearchParams } from 'react-router-dom'
import './CrossClientResultsFilter.scss'

export const CrossClientNameFilter = () => {
  const dispatch = useAppDispatch()

  const [searchParams, setSearchParams] = useSearchParams()

  const initialClientName = searchParams.get('clientName') ?? ''
  const [clientName, setClientName] = useState<string>(initialClientName)

  const initialized = useRef(false)

  const filterClients = useCallback(
    (clientName: string) => {
      const trimmed = clientName.trim()
      dispatch(setCrossClientSearch({ clientName: trimmed || null }))

      setSearchParams(
        (prev) => {
          if (clientName) {
            prev.set('clientName', clientName)
          } else {
            prev.delete('clientName')
          }
          return prev
        },
        { replace: true },
      )
    },
    [dispatch, setSearchParams],
  )

  useEffect(() => {
    if (initialized.current) {
      return
    }
    initialized.current = true
    if (initialClientName) {
      filterClients(initialClientName)
    }
  }, [filterClients, initialClientName])

  const handleClientNameChanged = useDebouncedCallback(filterClients, 300)

  return (
    <div className='d-flex gap-2 align-items-center form-control rounded-3 zocks-px-0.75 zocks-py-0.375 cross-client-results-filter'>
      <i className='bi bi-search fs-6'></i>
      <Form.Control
        className='p-0 border-0 paragraph-small'
        type='text'
        value={clientName}
        onChange={(e) => {
          setClientName(e.currentTarget.value)
          handleClientNameChanged(e.currentTarget.value)
        }}
        placeholder='Search clients'
      />
    </div>
  )
}
